import { InstructorsContent } from '@features/instructors/components/content/InstructorsContent';
import { InstructorsHeader } from '@features/instructors/components/header/InstructorsHeader';
import { InstructorsDataProvider } from '@features/instructors/contexts/data/InstructorsDataProvider';
import { InstructorsFilterProvider } from '@features/instructors/contexts/filter/InstructorsFilterProvider';
import { ManageInstructorsSelectionProvider } from '@features/instructors/contexts/manage-instructors-selection/ManageInstructorsSelectionProvider';
import { InstructorsProcessingRequestsProvider } from '@features/instructors/contexts/processing-requests/InstructorsProcessingRequestsProvider';
import { InstructorsUnapprovedProvider } from '@features/instructors/contexts/unapproved/InstructorsUnapprovedProvider';
import * as React from 'react';
import { Outlet } from 'react-router-dom';

import styles from './InstructorsPage.module.css';

const InstructorsPage = React.memo((): React.ReactElement => {
  return (
    <InstructorsFilterProvider>
      <InstructorsDataProvider>
        <InstructorsUnapprovedProvider>
          <InstructorsProcessingRequestsProvider>
            <ManageInstructorsSelectionProvider>
              <div
                data-testid="instructors-page"
                className={styles.instructorsPage}
              >
                <InstructorsHeader />
                <div className={styles.pageContent}>
                  <InstructorsContent />
                </div>
                <Outlet />
              </div>
            </ManageInstructorsSelectionProvider>
          </InstructorsProcessingRequestsProvider>
        </InstructorsUnapprovedProvider>
      </InstructorsDataProvider>
    </InstructorsFilterProvider>
  );
});

InstructorsPage.displayName = 'InstructorsPage';
export { InstructorsPage };
